import useStore from 'hooks/useStore';
import { isEmpty } from 'lodash';
import React from 'react';
import styled from 'styled-components';

const NotifyBadge = ({ style = {} }) => {
  const { state } = useStore();
  const { notifications } = state;
  const notificationsUnRead = !isEmpty(notifications)
    ? notifications?.filter(({ read }) => !read)
    : [];

  if (isEmpty(notifications)) return null;
  if (isEmpty(notificationsUnRead)) return null;
  return (
    <NotifyBadgeStyled style={style}>
      {notificationsUnRead?.length}
    </NotifyBadgeStyled>
  );
};

const NotifyBadgeStyled = styled.span`
  font-family: var(--ff-primary);
  line-height: 20px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: var(--ds-c-white);
  text-decoration: none;
  text-align: center;
  padding-top: 2px;
  margin-left: 4px;

  display: inline-block;
  width: 24px;
  height: 24px;
  background: #e72631;
  border-radius: 100%;
  user-select: none;
  position: absolute;
  right: 10px;
`;

export default NotifyBadge;
